import { combineReducers } from '@reduxjs/toolkit'
import { persistReducer } from 'redux-persist'
import { cardinalApiRtk } from './services/auth.api'
import { app, persistConfig } from './app'
import { practitionerApiRtk } from './api/practitionerApi'
import { userApiRtk } from './api/userApi'
import { patientApiRtk } from './api/patientApi'
import { deviceApiRtk } from './api/deviceApi'
import { contactApiRtk } from './api/contactApi'
import { msgGwApiRtk } from './api/msgGwApi'
import { codeApiRtk } from './api/codeApi'
import { interopApiRtk } from './api/interopApi'
import { localDocumentsApiRtk } from './localDocuments'
import { documentApiRtk } from './api/documentApi'

export const appReducer = combineReducers({
  app: app.reducer,
  cardinalApi: cardinalApiRtk.reducer,
  codeApi: codeApiRtk.reducer,
  interopApi: interopApiRtk.reducer,
  practitionerApi: practitionerApiRtk.reducer,
  userApi: userApiRtk.reducer,
  deviceApi: deviceApiRtk.reducer,
  patientApi: patientApiRtk.reducer,
  contactApi: contactApiRtk.reducer,
  msgGwApi: msgGwApiRtk.reducer,
  localDocumentsApi: localDocumentsApiRtk.reducer,
  documentApi: documentApiRtk.reducer,
})

export const persistedReducer = persistReducer(persistConfig, appReducer)

export type AppState = ReturnType<typeof appReducer>
